import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offer-verified__room-details-container" }
const _hoisted_2 = { class: "offer-verified__room-details" }

import FeatureList from '@lmt-rpb/FeatureList/FeatureList.vue';
import type { TourOperator } from '@interfaces/common';
import type { MergedOfferItemData } from '@interfaces/offer';
import OfferVerifiedOperator from './OfferVerifiedOperator.vue';

interface Props {
	offerData: MergedOfferItemData;
	operator: TourOperator;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OfferVerifiedRoomDetails',
  props: {
    offerData: {},
    operator: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(OfferVerifiedOperator, { operator: _ctx.operator }, null, 8 /* PROPS */, ["operator"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(FeatureList, {
        offer: _ctx.offerData,
        "is-first-feature-bold": true,
        location: "verifiedOffer"
      }, null, 8 /* PROPS */, ["offer"])
    ])
  ]))
}
}

})